module.exports = __webpack_public_path__ + "static/media/icon-dashboard.6e744e53.svg";